export default __webpack_public_path__ + "static/media/simply-sip-2.e83c2ab9.png";